import { useQuery } from '@tanstack/react-query'

import { authAPI } from '@/api/new-api'

export type GetVisitorAnalyticsRequest = {
  buildingId?: number
  period: string
}

export type VisitorAnalytics = {
  visitors: number
  checkIns: number
}

export const getVisitorAnalyticsQueryKey = (data: GetVisitorAnalyticsRequest) => [
  'useGetVisitorAnalytics',
  data,
]

export const getVisitorAnalytics = async (
  data: GetVisitorAnalyticsRequest,
  signal?: AbortSignal,
): Promise<VisitorAnalytics> => {
  const response = await authAPI.get<VisitorAnalytics>(
    `/visitor-stats/${data.buildingId}/${data.period}`,
    { signal },
  )
  return response.data
}

export const useGetVisitorAnalytics = (data: GetVisitorAnalyticsRequest) => {
  return useQuery({
    enabled: !!data.buildingId,
    queryFn: ({ signal }) => getVisitorAnalytics(data, signal),
    queryKey: getVisitorAnalyticsQueryKey(data),
  })
}
